<template>
  <outro-template :show-exit-button="true" :status="status" :memo="{ label: 'Les règles relatives aux primes', link: 'files/memo4_primes_pdb.pdf' }">
    <template v-slot:title>
      Déclarer une prime, un jour férié ou du travail de nuit
    </template>
    <template v-slot:sub-title>
      Les règles relatives aux primes
    </template>
    <template v-slot:score-title>
      Vous avez obtenu {{ score }} points !
    </template>
    <template v-slot:success-detail-title>
      Bravo !
    </template>
    <template v-slot:success-detail-content>
      Vous connaissez bien les règles relatives aux primes.
    </template>
    <template v-slot:normal-detail-title>
      Vous n'êtes pas complètement au point sur les règles régissant les primes.
    </template>
    <template v-slot:normal-detail-content>
      Prenez le temps de relire l'infographie.
    </template>
    <template v-slot:fail-detail-title>
      Vous allez devoir vous mettre à niveau pour ne pas faire d'impairs lors du déclenchement des primes.
    </template>
    <template v-slot:fail-detail-content>
      N'hésitez pas à repasser le module.
      <br>
      <button @click="navigateTo('intro')" class="button retry-button">Réessayer</button>
    </template>
  </outro-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'Outro',
  mixins: [stepMixin],
  computed: {
    score () {
      return this.$store.state.quizzScore
    },
    status () {
      return this.$store.getters.quizzStatus
    }
  }
}
</script>

<style lang="scss">
</style>
